import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fefcfe;
  /* width: 710px;
  height: 925px; */
  border-radius: 0 16px 16px 0;
  box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.25);
  padding-left: 40px;

  @media (max-width: 1250px){
    padding-left: 10px;
  }
`;

export const Border = styled.div`
  width: 100px;
`;

export const Content = styled.div`
  padding: 20px 0 0 20px;
`;
